import HelperClassContainer from "../../components/uiKits/helperClasses";

const HelperClasses = () => {
  return <HelperClassContainer />;
};

export default HelperClasses;
